import script from "./AssessorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessorForm.vue?vue&type=script&setup=true&lang=js"

import "./AssessorForm.vue?vue&type=style&index=0&id=967bd184&lang=scss"

export default script